import { getStepProfiles } from '@/api/traceStepProfiles'

const feature = {
  state: {
    stepalphaprofile: null,
    stepbravoprofile: null,
    stepcharlieprofile: null,
    stepdeltaprofile: null,
    stepechoprofile: null
  },
  getters: {
    stepalphaprofile: state => state.stepalphaprofile,
    stepbravoprofile: state => state.stepbravoprofile,
    stepcharlieprofile: state => state.stepcharlieprofile,
    stepdeltaprofile: state => state.stepdeltaprofile,
    stepechoprofile: state => state.stepechoprofile
  },
  mutations: {
    SET_STEP_ALPHA_PROFILE: (state, stepalphaprofile) => {
      state.stepalphaprofile = stepalphaprofile
    },
    SET_STEP_BRAVO_PROFILE: (state, stepbravoprofile) => {
      state.stepbravoprofile = stepbravoprofile
    },
    SET_STEP_CHARLIE_PROFILE: (state, stepcharlieprofile) => {
      state.stepcharlieprofile = stepcharlieprofile
    },
    SET_STEP_DELTA_PROFILE: (state, stepdeltaprofile) => {
      state.stepdeltaprofile = stepdeltaprofile
    },
    SET_STEP_ECHO_PROFILE: (state, stepechoprofile) => {
      state.stepechoprofile = stepechoprofile
    },
  },
  actions: {
    async GetStepProfiles({ commit }, branchSelected) {
      try {
        const resp = await getStepProfiles(branchSelected)
        commit('SET_STEP_ALPHA_PROFILE', resp.stepalphaprofile)
        commit('SET_STEP_BRAVO_PROFILE', resp.stepbravoprofile)
        commit('SET_STEP_CHARLIE_PROFILE', resp.stepcharlieprofile)
        commit('SET_STEP_DELTA_PROFILE', resp.stepdeltaprofile)
        commit('SET_STEP_ECHO_PROFILE', resp.stepechoprofile)
      } catch (err) {
        console.log(err)
      }
    }
  }
}

export default feature



// WEBPACK FOOTER //
// ./src/store/modules/trace.js